module.exports = __webpack_public_path__ + "img/megaphone.5495c898.png";